import React from 'react'
import styled from 'styled-components'
import { AddCardModalText } from 'src/components/Global/Text/TitleText'
import { ArrowModal, Plus } from 'src/assets'
import { ModalButton } from 'src/components/Global/Button/Button'

import { Link, useLocation } from 'react-router-dom'
const TypesOfCards = [
  {
    id: '1',
    Title: 'Master Card',
    Number: '**** **** **** 0752',
  },
  {
    id: '2',
    Title: 'Visa',
    Number: '**** **** **** 0752',
  },
]

const AddCardWrpper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  padding-top: 43px;
  .card {
    width: auto;
    height: 64px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding-left: 60px;
    padding-right: 20px;
    margin-top: 20px;
    cursor: pointer;
  }
  .top {
    margin-top: 40px;
  }
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .two {
    display: flex;
    align-items: center;
    padding-left: 20px;
    justify-content: space-between;
  }
  .three {
    display: flex;
    align-items: center;
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 12px;
    color: ${({ theme }) => theme.colors.dark};
  }
  h2 {
    font-weight: bold;
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 17px;
  }
  .new {
    color: ${({ theme }) => theme.colors.CollaboBlue};
    padding-left: 16px;
  }
  .choose {
    margin-bottom: 30px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 30px -47px;
  }
`
const AddCard = () => {
  let location = useLocation()
  return (
    <AddCardWrpper>
      <AddCardModalText>Select payment method</AddCardModalText>
      <p className="choose">Choose from the options below to save</p>
      {TypesOfCards.map((item) => (
        <div className="card" key={item.id}>
          <h2>{item.Title}</h2>
          <p className="cardNo">{item.Number}</p>
        </div>
      ))}
      <div className="card info">
        <h2>Pay with bank</h2>
      </div>
      <div className="card two">
        <div className="three">
          <img src={Plus} alt="" />
          <h2 className="new">Add new card</h2>
        </div>
        <img src={ArrowModal} alt="" />
      </div>
      <div className="top">
        <div className="line"></div>
        <Link to={`/quicksave-two`} state={{ backgroundLocation: location }}>
          <ModalButton>Continue</ModalButton>
        </Link>
      </div>
    </AddCardWrpper>
  )
}
export { AddCard }
